import * as React from "react";
function SvgRefresh(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.376 5.293c-1.238.3-2.37.938-3.27 1.84a6.95 6.95 0 00-1.698 7.008.21.21 0 00.316.111l1.126-.74a.84.84 0 011.285.871l-.768 3.703a.84.84 0 01-.991.655l-3.704-.763a.84.84 0 01-.292-1.526l1.176-.775a.208.208 0 00.08-.252A9.035 9.035 0 0114.763 3.43a1.05 1.05 0 11-.639 2 6.92 6.92 0 00-3.749-.137zm11.393 1.123a.84.84 0 01.218.436.84.84 0 01-.38.859l-1.131.71a.208.208 0 00-.084.253A9.034 9.034 0 019.337 20.667a1.051 1.051 0 11.62-2.007A6.932 6.932 0 0018.6 9.9a.211.211 0 00-.128-.134.208.208 0 00-.184.023l-1.212.761a.84.84 0 01-1.267-.898l.84-3.687a.841.841 0 011.01-.632l3.687.84a.84.84 0 01.423.243z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgRefresh);
export default ForwardRef;
